export const APPNAME = process.env.REACT_APP_NAME || 'MetaStake';